/**
 * @generated SignedSource<<4cf2c556803d679de007f748af7387bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type TimeRegistrationModalRetainerPeriodQuery$variables = {
  projectId: string;
  year: number;
  month: number;
  day: number;
  taskId?: string | null;
  excludeTimeRegId?: string | null;
};
export type TimeRegistrationModalRetainerPeriodQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly retainerPeriodStatus: {
        readonly name: string | null;
        readonly budgetType: PERIOD_BUDGET_TYPE;
        readonly locked: boolean;
        readonly targetMinutes: number | null;
        readonly registeredMinutes: number | null;
        readonly entryCounts: boolean;
        readonly moveRefused: boolean;
      } | null;
    } | null;
  } | null;
};
export type TimeRegistrationModalRetainerPeriodQuery = {
  variables: TimeRegistrationModalRetainerPeriodQuery$variables;
  response: TimeRegistrationModalRetainerPeriodQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "day"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeTimeRegId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v6 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "day",
      "variableName": "day"
    },
    {
      "kind": "Variable",
      "name": "excludeTimeRegId",
      "variableName": "excludeTimeRegId"
    },
    {
      "kind": "Variable",
      "name": "month",
      "variableName": "month"
    },
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    },
    {
      "kind": "Variable",
      "name": "year",
      "variableName": "year"
    }
  ],
  "concreteType": "RetainerPeriodStatusType",
  "kind": "LinkedField",
  "name": "retainerPeriodStatus",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entryCounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moveRefused",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeRegistrationModalRetainerPeriodQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TimeRegistrationModalRetainerPeriodQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed238ac3cff41431f9a3ee3d0c8be011",
    "id": null,
    "metadata": {},
    "name": "TimeRegistrationModalRetainerPeriodQuery",
    "operationKind": "query",
    "text": "query TimeRegistrationModalRetainerPeriodQuery(\n  $projectId: ID!\n  $year: Int!\n  $month: Int!\n  $day: Int!\n  $taskId: ID\n  $excludeTimeRegId: ID\n) {\n  viewer {\n    project(internalId: $projectId) {\n      retainerPeriodStatus(year: $year, month: $month, day: $day, taskId: $taskId, excludeTimeRegId: $excludeTimeRegId) {\n        name\n        budgetType\n        locked\n        targetMinutes\n        registeredMinutes\n        entryCounts\n        moveRefused\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7dfe14bc1866f096ade1bd8d69e9b21";

export default node;
